import { Component, type ErrorInfo, type ReactNode } from 'react';

interface DiscussionErrorBoundaryProps {
  children: ReactNode;
  fallback: ReactNode;
}

interface DiscussionErrorBoundaryState {
  hasError: boolean;
}

/**
 * Isolates the discussion panel so a rendering failure inside the embedded chat (e.g. a
 * DevExtreme template update loop) cannot white-out the surrounding record form.
 */
export class DiscussionErrorBoundary extends Component<
  DiscussionErrorBoundaryProps,
  DiscussionErrorBoundaryState
> {
  state: DiscussionErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): DiscussionErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    if (typeof console !== 'undefined') {
      console.error('[discussion] panel crashed; form kept open', error, info.componentStack);
    }
  }

  render(): ReactNode {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}
